import React, { CSSProperties } from "react";
import { ContainerEl, IEDocState } from "./index";

class EDoc extends ContainerEl<HTMLBodyElement, IEDocState> {
    private htmlRef: React.RefObject<HTMLHtmlElement> = React.createRef();

    getStyles = (): CSSProperties => {
        let styles: CSSProperties = {
            backgroundColor: "transparent",
        };

        if (this.props.Brand) {
            const { Brand } = this.props;

            styles = {
                backgroundColor: "transparent",
                color: Brand.fontColor,
                fontFamily: Brand.fontFamily,
                fontSize: this.__unitSize(Brand.documentFontSize),
                lineHeight: "initial",
                padding: 0,
                margin: 0,
            };
        }

        return styles;
    };

    renderStyles() {
        return (
            <style jsx>{`
                <!--[if gte mso 9]
                    > <xml
                    > <o:officedocumentsettings
                    > <o:allowpng/
                    > <o:pixelsperinch
                    > 96</o:pixelsperinch
                    > </o:officedocumentsettings
                    > </xml
                    > <![endif]--
                    > body {
                    -webkit-text-size-adjust: 100%;
                    -ms-text-size-adjust: 100%;
                }
            `}</style>
        );
    }

    componentDidMount() {
        const htmlTag = this.htmlRef.current;
        htmlTag?.setAttribute("xmlns", "http://www.w3.org/1999/xhtml");
        htmlTag?.setAttribute("xmlns:v", "urn:schemas-microsoft-com:vml");
        htmlTag?.setAttribute(
            "xmlns:o",
            "urn:schemas-microsoft-com:office:office"
        );
    }

    render(): JSX.Element {
        const { Brand, ...rest } = this.props;

        return (
            <html lang="en" ref={this.htmlRef}>
                <head>
                    <meta
                        name="viewport"
                        content="width=device-width; initial-scale=1.0; maximum-scale=1.0; user-scalable=no;"
                    ></meta>
                    <meta
                        http-equiv="Content-Type"
                        content="text/html; charset=utf-8"
                    ></meta>
                    <meta name="color-scheme" content="light dark"></meta>
                    <meta
                        name="supported-color-schemes"
                        content="light dark"
                    ></meta>
                    <meta name="format-detection" content="telephone=no"></meta>
                    <meta name="format-detection" content="email=no"></meta>

                    {this.renderStyles()}
                </head>
                <body style={this.getStyles()} {...rest}>
                    {this.__passPropsToChildren({ Brand: Brand })}
                </body>
            </html>
        );
    }
}

export { EDoc };
